import React, { useContext, useState } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const { isDark } = useContext(StyleContext);
  const [activeProjectId, setActiveProjectId] = useState(null);

  if (!bigProjects.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="startup-card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, k) => {
                          return (
                            <span
                              key={k}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => openUrlInNewTab(link.url)}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                        <span
                          className={
                            isDark ? "dark-mode project-tag" : "project-tag"
                          }
                          onClick={() => setActiveProjectId(i)}
                        >
                          Details
                        </span>
                      </div>
                    ) : null}
                  </div>

                  {/* Overlay */}
                  {/* Overlay */}
                  <div className={`project-card-overlay ${activeProjectId === i ? 'active' : ''}`}>
                    <div className="header">
                      <h5 className="card-title" style={{ margin: 0, fontSize: '1.2rem' }}>{project.projectName}</h5>
                      <button className="close-btn" onClick={() => setActiveProjectId(null)}>×</button>
                    </div>
                    <p className="project-detail-text">
                      {project.projectDetails}
                    </p>
                    <button className="back-btn" onClick={() => setActiveProjectId(null)}>
                      Back
                    </button>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
